import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { InfoPanel } from 'react-science/ui';
import useSpectrum from '../hooks/useSpectrum';
const emptyData = { info: {}, meta: {} };
export default function InformationPanel() {
    const { info, meta, customInfo } = useSpectrum(emptyData);
    const data = useMemo(() => [
        { description: 'Custom information', data: customInfo || {} },
        { description: 'Spectrum information', data: info || {} },
        { description: 'Other spectrum parameters', data: meta || {} },
    ], [customInfo, info, meta]);
    return _jsx(InfoPanel, { data: data, title: "" });
}
